import { Box } from "@mui/material";

import { useScoutChat } from "../hooks/useScoutChat";
import { ChatChrome } from "./ChatChrome";
import { NewChat } from "./NewChat";

export const ScoutChat = () => {
  const { messages, isSending, handleSubmit } = useScoutChat();

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
      }}
    >
      {messages.length === 0 ? (
        <NewChat onSubmit={handleSubmit} isSending={isSending} />
      ) : (
        <ChatChrome messages={messages} onSubmit={handleSubmit} isSending={isSending} />
      )}
    </Box>
  );
};
